import { Observable } from "rxjs";
import { AppConfigService } from "src/app/app.config.service";
import { ConfigEnvironment } from "src/app/app.interfaces";

export const appConfigFactory = (
    appConfigService: AppConfigService,
): (() => Observable<ConfigEnvironment>) => {
    return () => appConfigService.loadConfig();
};

export const appConfigEnvironmentFactory = (
    appConfigService: AppConfigService,
): ConfigEnvironment => {
    return appConfigService.environment;
};

export const serviceWorkerInitializerFactory = (
    appConfigService: AppConfigService,
): (() => Promise<void>) => {
    return () => appConfigService.initializeServiceWorker();
};
